import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/funding-source";

export const pagingFundingSource = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getFundingSourceById = (fundingSourceId) => axios.get(API_PATH + "/get-by-id/" + fundingSourceId);

export const saveOrUpdateFundingSource = fundingSource => axios.post(API_PATH + "/save", fundingSource);

export const deleteFundingSource = fundingSourceId => axios.delete(API_PATH + '/mark-delete/' + fundingSourceId);

